export default "__VITE_ASSET__C8lw_8Xk__"